import { Button, Icon } from '@driftt/tide-core-legacy'
import './style.styl'

import { CUSTOMER_API } from 'constants/ResourcesConstants'
import { api } from 'app/modules/conversation/api' 

const LEANDATA_INTEGRATION_SWITCH = 'leandata-integration-switch'
const LEANDATA_HELPDOC = 'https://gethelp.drift.com/hc/en-us/articles/360019667073-Drift-and-LeanData'

const makeConnectButtonPressConfig = (enabled, successCallback) => ({
  url: `${CUSTOMER_API}/integrations/leandata/toggles`,
  method: 'patch',
  data: {
    enabled,
  },
  successMessage: `Successfully sent request to LeanData`,
  errorMessage: `Something went wrong and we couldn’t get your request to LeanData`,
  clickId: LEANDATA_INTEGRATION_SWITCH,
  successCallback,
})

const successCallbackWithEmail = (successCallback) => {
  api.sendLeanDataIntegrationEmail()
  successCallback()
}

const LeanDataDisconnected = ({ asyncButtonPress, togglePending, integrationsFetchPending, fetchIntegrationStates }) => (
  <div className="leandata-connected-view-container">
        <p>Connect your account to Drift to assign leads to reps using your LeanData rules. <a href={LEANDATA_HELPDOC}>Learn more</a></p>
        <div>
          <h3 className="integration-leandata-how-it-works-title">How it works</h3>
          <ul className="integration-leandata-how-it-works-list">
            <li><Icon name="arrow-2-right" width={16} className="how-it-works-icon" />Connect your LeanData account with Drift.</li>
            <li><Icon name="arrow-2-right" width={16} className="how-it-works-icon" />When you connect LeanData through Drift, we’ll send an email to the LeanData team letting them know to turn on the integration.</li>
            <li><Icon name="arrow-2-right" width={16} className="how-it-works-icon" />Create a new conversation routing rule using LeanData.</li>
            <li><Icon name="arrow-2-right" width={16} className="how-it-works-icon" />When visitors chat in, Drift will automatically connect them with the right person according to LeanData.</li>
          </ul>
          <p className="integration-leandata-extra-note"><strong>Note:</strong> Just remember to make sure that teammates are in Salesforce and Drift.</p>
        </div>
    <div className="leandata-connected-disconnect-container">
    {<Button type="primary" loading={togglePending || integrationsFetchPending} onClick={() => asyncButtonPress(makeConnectButtonPressConfig(true, successCallbackWithEmail(fetchIntegrationStates)))}>Request Access from LeanData</Button>}    
    <p className="integration-leandata-extra-note">We'll include your email in our request to LeanData. They'll reach out to you there once everything is enabled.</p>
    </div>
  </div>
)

export default LeanDataDisconnected



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/LeanData/components/LeanDataDisconnected/index.js